import type { FaireProductEntity } from "../../entity_types/product";

export const p_mmw2tqeb4h: FaireProductEntity = {
  token: "p_mmw2tqeb4h",
  type: "product",
  name: "Brass Anubis Crafts Decoration Desktop Ornaments",
  brandToken: "b_nex9pcmkzj",
  brandName: "",
  imageUrl:
    "https://cdn.faire.com/fastly/0add9c13384a892e8e73d4706db0ee2974ba6339f85cd4fe4ed61065ef162fc8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5c89d4ef4e4ccc57b7e2745009b83cd6b20655e73a9407fefd437f9a2b3f5826.jpeg",
    "https://cdn.faire.com/fastly/87eeb1082a926087f06f67acba723f2685488c019154a024448e5ebae309b114.jpeg",
    "https://cdn.faire.com/fastly/7f17360ca6149a766b62df92777ad33502ae998e7cc76f11cfa0798a452e3f7b.jpeg",
  ],
  priceDollars: 11.84,
  description: "\nType: Ornaments\nMaterial: Brass\nSize: 31mm*35mm\n\n\n",
  tags: [],
  msrpDollars: 23.67,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-07T04:57:38.648Z",
    importedBy: "gen-brand-update-tile-products.mjs",
  },
  categoryTokens: [],
};
